export const SEND_EMAIL_TO_PRODUCER 				 = 'SEND_EMAIL_TO_PRODUCER'
export const SEND_EMAIL_TO_PRODUCER_SUCCESS  = 'SEND_EMAIL_TO_PRODUCER_SUCCESS'
export const SEND_EMAIL_TO_PRODUCER_FAIL     = 'SEND_EMAIL_TO_PRODUCER_FAIL'